import type { ReactNode } from 'react';

interface PageHeaderProps {
  kicker?: string;
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}

export function PageHeader({ kicker, title, subtitle, actions }: PageHeaderProps) {
  const showKicker =
    Boolean(kicker) &&
    kicker!.trim().toLowerCase() !== title.trim().toLowerCase() &&
    !title.toLowerCase().includes(kicker!.trim().toLowerCase());

  return (
    <div className="mb-8 text-center md:mb-10">
      {showKicker ? (
        <p className="mb-3 text-sm font-medium text-fiesta-yellow/80">
          {kicker}
        </p>
      ) : null}
      <h1 className="font-display text-3xl font-semibold tracking-tight text-white sm:text-4xl md:text-5xl">
        {title}
      </h1>
      {subtitle ? (
        <p className="mx-auto mt-3 max-w-2xl text-base leading-relaxed text-zinc-400 sm:text-lg">
          {subtitle}
        </p>
      ) : null}
      {actions ? <div className="mt-6">{actions}</div> : null}
    </div>
  );
}
